import styled from "@emotion/styled";
import { ThemeMode } from "@smartsheet/sds-theme-internal";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TypeRampV2 } from "../../../typography";

interface SelectedOptionFacadeProps {
    isContentBeforeVisible: boolean;
    themeMode: ThemeMode;
}

export const SelectedOptionFacade = styled(TypeRampV2)<SelectedOptionFacadeProps>`
    font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};
    line-height: 18px;
    min-width: 0;
    overflow-wrap: break-word;
    color: var(--sds--form--color--value, inherit);
`;
